/* -------------------------------------------------------------------------- */
/*                                Schema Sensors                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sensor = new schema.Entity('sensors', {}, { idAttribute: 'sensorId' });
export const sensors = new schema.Array(sensor);
